"use client";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { useEffect, useState } from "react";

import { useRouter, useSearchParams, usePathname } from "next/navigation";
const all = {
    "_id": "all",
    "title": "All",
    "slug": "all",
    "description": "All Products",
    "isActive": true,
};

export const FilterByCategory = ({ data }) => {
    const [categories, setCategories] = useState(data || []);
    const [selectedCatgory, setselectedCatgory] = useState(all);
    
    const router = useRouter();
    const searchParams = useSearchParams();
    const pathname = usePathname();

    useEffect(() => {
        // Fetch categories from API and update state
        if (data && Array.isArray(data) && data.length > 0) {
            setCategories([all, ...data]);
        }
    }, [data]);
 useEffect(() => {
    const segments = pathname.split("/");
    const categorySlug = segments[2] || "all"; 

    const found = categories.find(
        (item) => item.slug === categorySlug
    );

    setselectedCatgory(found || all);
}, [pathname, categories]);

    const changeCategory = (category) => {
        if (category === "all") {
            router.push("/");
        } else {
            router.push(`/?category=${category}`);
        }
    };
    const doChange = (e) => {
        changeCategory(e?.value?.slug)
    }
    return (
        <div className="flex gap-2 align-items-center">
        <Dropdown
            value={selectedCatgory}
            onChange={doChange}
            options={categories}
            optionLabel="title"
            placeholder="Filter By"
        />
        {(selectedCatgory  && selectedCatgory?.slug !=='all') && <Button onClick ={()=> router.push("/")} label ="View ALL Products"  className ='surface-50 text-white' size= "small "/>}
        </div>
    );
}
